import React from "react";

const TermOfService = () => {
  return (
    <div
      className=" lg:w-[920px] w-[353px] mx-auto  flex flex-col gap-14 lg:py-32 py-24 justify-center items-center"
      id="terms"
    >
      <h1 className="text-[#101828] text-2xl font-bold">Terms Of Service</h1>
      <div className="flex flex-col gap-14 ">
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            1. INTRODUCTION
          </h3>
          <p className="text-base leading-6">
            <strong>1.1</strong> These Terms of Service ("Terms") constitute a
            legally binding agreement between you ("User", "you", or "your") and
            Flit Technologies Private Limited ("Flit", "we", "us", or "our"), a
            company incorporated under the Companies Act, 2013, having its
            registered office at 346B, SHIV SADAN, MANGALAM, VIHAR COLONY,
            JAGDEO PATH, Patna Aerodrome, Phulwari, Patna- 800014, Bihar. <br />{" "}
            <strong>1.2</strong> These Terms govern your access to and use of
            the Flit application, website, and services (collectively, the
            "Platform"). By accessing or using our Platform, you agree to be
            bound by these Terms. If you do not agree to these Terms, please do
            not access or use our Platform. <br /> <strong>1.3</strong> Flit
            reserves the right to change, modify, add, or remove portions of
            these Terms at any time. It is your responsibility to check these
            Terms periodically for changes. Your continued use of the Platform
            following the posting of changes will mean that you accept and agree
            to the changes. <br /> <strong>1.4</strong> Please read these Terms
            carefully before accessing or using the Platform. If you have any
            questions about these Terms, please contact us using the information
            provided in Section 24.11.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            2. DEFINITIONS
          </h3>
          <p className="text-base leading-6">
            For the purpose of these Terms, the following terms shall have the
            meanings assigned to them below: <br /> <br /> <strong>2.1</strong>{" "}
            "Applicable Laws" means all applicable laws, statutes, rules,
            regulations, orders, notifications, circulars, guidelines,
            directives, and ordinances of any jurisdiction. <br />{" "}
            <strong>2.2</strong> "Content" means text, graphics, images, music,
            software, audio, video, information, or other materials. <br />
            <strong>2.3</strong>
            "Delivery Partner" means an independent third-party service provider
            who provides delivery services through the Platform. <br />
            <strong>2.4</strong> "Delivery Services" means the hyperlocal
            pick-up and delivery services provided by Delivery Partners. <br />
            <strong>2.5</strong>
            "Personal Information" means any information that can be used to
            identify you, as further described in our Privacy Policy. <br />
            <strong>2.6</strong>
            "Platform" means the Flit mobile application, website, and related
            services. <br /> <strong>2.7</strong> "User" means any individual
            who accesses or uses the Platform. <br /> <strong>2.8</strong> "User
            Account" means the account created by you to access and use the
            Platform. <br /> <strong>2.9</strong> "Terms" means these Terms of
            Service, as may be amended from time to time.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            3. PLATFORM DESCRIPTION
          </h3>
          <p className="text-base leading-6">
            <strong>3.1</strong>Flit is a technology platform that connects
            Users with independent third-party Delivery Partners for hyperlocal
            delivery services. Flit does not provide delivery services directly
            but facilitates the connection between Users and Delivery Partners
            through our Platform. <br /> <strong>3.2</strong> Flit's primary
            role is to provide the technology platform that enables Users to
            connect with Delivery Partners for delivery services. We are not a
            delivery company and do not transport or deliver items directly. We
            act as an intermediary between Users and Delivery Partners. <br />{" "}
            <strong>3.3</strong> By using our Platform, you acknowledge and
            agree that Flit is not responsible for the acts or omissions of
            Delivery Partners and that the Delivery Services are provided to you
            by independent Delivery Partners who are not employed by Flit.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            4. ELIGIBILITY
          </h3>
          <p className="text-base leading-6">
            <strong>4.1</strong> To use our Platform, you must: a) Be at least
            18 years of age or above; b) Be capable of entering into a legally
            binding agreement; c) Not be prohibited from using the Platform
            under Applicable Laws; and d) Have a valid mobile phone number and
            email address. <br /> <strong>4.2</strong> Flit reserves the right
            to terminate or suspend your account without notice if we discover
            that you are under 18 years of age or otherwise do not meet the
            eligibility criteria. <br /> <strong>4.3</strong> If you are using
            the Platform on behalf of a business or other entity, you represent
            and warrant that you have the necessary authority to bind that
            business or entity to these Terms and that you are agreeing to these
            Terms on behalf of that business or entity.
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            5. USER ACCOUNTS
          </h3>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.1 Registration
              </h3>
              <p>
                <strong>5.1.1</strong> To access our services, you must register
                for a Flit account by providing accurate, complete, and current
                information as prompted by the registration form.
                <br /> <strong>5.1.2</strong> You may be required to provide
                your name, mobile number, email address, and other information
                to complete the registration process.
                <br /> <strong>5.1.3</strong> You agree to maintain and promptly
                update your account information to keep it accurate, current,
                and complete.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.2 Verification
              </h3>
              <p>
                <strong>5.2.1</strong> We may, but are not obligated to, verify
                your identity or account information.
                <br /> <strong>5.2.2</strong> You authorize us to make
                inquiries, directly or through third parties, that we consider
                necessary to verify your identity or protect you and/or us
                against fraud or other financial crime, and to take action we
                reasonably deem necessary based on the results of such
                inquiries.
                <br /> <strong>5.2.3</strong> When we carry out these inquiries,
                you acknowledge and agree that your personal information may be
                disclosed to credit reference and fraud prevention or financial
                crime agencies and that these agencies may respond to our
                inquiries in full.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.3 Account Security
              </h3>
              <p>
                <strong>5.3.1</strong> You are responsible for maintaining the
                confidentiality of your account credentials and for all
                activities that occur under your account.
                <br /> <strong>5.3.2</strong> You agree to: a) Create a strong
                password and keep it confidential; b) Restrict access to your
                mobile device and your User Account; c) Notify us immediately of
                any unauthorized use of your account or any other breach of
                security; and d) Ensure that you log out from your account at
                the end of each session.
                <br /> <strong>5.3.3</strong> We will not be liable for any loss
                or damage arising from your failure to comply with this section.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.4 One Account Per User
              </h3>
              <p>
                <strong>5.4.1</strong> You may maintain only one active User
                Account with Flit.
                <br /> <strong>5.4.2</strong> If we discover or have reason to
                believe that you have created or are using multiple accounts, we
                reserve the right to suspend or terminate all your accounts.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.5 Termination by User
              </h3>
              <p>
                <strong>5.5.1</strong> You may terminate your User Account at
                any time by following the instructions on the Platform or by
                contacting our customer support.
                <br />
                <strong>5.5.2</strong> Upon termination, you will lose access to
                the Platform's services, and certain information may be retained
                by us as required by law or for legitimate business purposes.
                <br /> <strong>5.5.3</strong> Termination of your account does
                not relieve you of any obligations that accrued prior to
                termination.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                5.6 Termination by Flit
              </h3>
              <p>
                <strong>5.6.1</strong> We reserve the right to suspend or
                terminate your account at our sole discretion, without notice,
                for conduct that we believe violates these Terms or is harmful
                to other Users, Delivery Partners, third parties, or our
                business interests.
                <br />
                <strong>5.6.2</strong> Reasons for termination may include, but
                are not limited to: a) Violation of these Terms; b) Fraudulent
                or illegal activities; c) Abusive behavior towards Delivery
                Partners or Flit staff; d) Non-payment of fees; e) Inactive
                account for an extended period; or f) Any other reason that Flit
                deems appropriate.
                <br />
                <strong>5.6.3</strong> Upon termination, your right to use the
                Platform will immediately cease, and we may delete or restrict
                access to your User Account and any related information and
                files.
                <br />
                <strong>5.6.4</strong> We shall not be liable to you or any
                third party for any termination of your access to the Platform.
              </p>
            </div>
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">6. SERVICES</h3>

          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.1 Delivery Services
            </h3>
            <p>
              <strong>6.1.1</strong> Flit provides a technology platform that
              enables Users to request hyperlocal delivery services from
              Delivery Partners.
              <br /> <strong>6.1.2</strong> Users can request the pick-up and
              delivery of items through the Platform.
              <br /> <strong>6.1.3</strong>The specific services available may
              vary by location and are subject to change at our discretion.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.2 Service Availability
            </h3>
            <p>
              <strong>6.2.1</strong> Our services are available only in select
              cities and areas.
              <br /> <strong>6.2.2</strong> Service availability may vary
              depending on your location, time of day, and other factors.
              <br /> <strong>6.2.3</strong> We do not guarantee that the
              Platform or services will be available at all times.
              <br /> <strong>6.2.4</strong> We may, at our sole discretion,
              discontinue the Platform or services, either temporarily or
              permanently, with or without notice.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.3 Service Requests
            </h3>
            <p>
              <strong>6.3.1</strong> To request delivery services, you must
              provide accurate and complete information, including: a) Pick-up
              location and details; b) Delivery location and details; c) Contact
              information for pick-up and delivery; d) Item description; and e)
              Any special handling instructions.
              <br />
              <strong>6.3.1</strong> You acknowledge that providing incorrect or
              incomplete information may result in service delays, non-delivery,
              or additional charges.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.4 Order Acceptance
            </h3>
            <p>
              <strong>6.4.1</strong> Upon submitting a delivery request, the
              Platform will attempt to match you with an available Delivery
              Partner.
              <br />
              <strong>6.4.2</strong> We do not guarantee that a Delivery Partner
              will be available or will accept your request.
              <br />
              <strong>6.4.3</strong> A Delivery Partner may reject your request
              for any reason, including distance, timing, or safety concerns.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.5 Tracking and Communication
            </h3>
            <p>
              <strong>6.5.1</strong> Once a Delivery Partner accepts your
              request, you may track the status of your delivery through the
              Platform. <br />
              <strong>6.5.2</strong> You may also communicate with the Delivery
              Partner through the Platform. <br />
              <strong>6.5.3</strong> We may record and monitor all
              communications between you and the Delivery Partner for quality
              assurance, training, and safety purposes.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.6 Delivery Confirmation
            </h3>
            <p>
              <strong>6.6.1</strong> Upon delivery, you may be required to
              confirm receipt of the delivered items through the Platform, or
              the Delivery Partner may confirm delivery.
              <br />
              <strong>6.6.2</strong> Any disputes regarding delivery must be
              reported to us immediately.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.7 Prohibited Items
            </h3>
            <p>
              <strong>6.7.1</strong> You agree not to request the transportation
              of any illegal, dangerous, hazardous, inflammable, explosive,
              stolen, harmful, or prohibited items.
              <br />
              <strong>6.7.2</strong> A non-exhaustive list of prohibited items
              includes:
              <ul className="list-disc pl-5">
                <li>
                  Narcotics, illegal drugs, and other controlled substances
                </li>
                <li>Firearms, ammunition, weapons, or explosives</li>
                <li>Hazardous or toxic substances</li>
                <li>Stolen goods</li>
                <li>Counterfeit goods</li>
                <li>Cash or currency exceeding INR 2,000</li>
                <li>Personal identification documents</li>
                <li>Pornographic or obscene materials</li>
                <li>Live animals or insects</li>
                <li>Human remains or body parts</li>
                <li>
                  Perishable items requiring special handling or temperature
                  control, unless specifically agreed upon
                </li>
                <li>
                  Any goods or services that are unlawful under applicable laws
                </li>
              </ul>
              <br />
              <strong>6.7.3</strong> We reserve the right to refuse or cancel
              any delivery request that we believe involves prohibited items.
              <br />
              <strong>6.7.4</strong> In case of doubt, our decision regarding
              whether an item is prohibited shall be final and binding.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.8 Value Declaration and Insurance
            </h3>
            <p>
              <strong>6.8.1</strong> You are responsible for declaring the
              accurate value of the items to be delivered.
              <br />
              <strong>6.8.2</strong> Flit's liability for lost or damaged items
              is limited as described in the Limitation of Liability section.
              <br />
              <strong>6.8.3</strong> If you wish to insure your items for higher
              value, you must arrange for separate insurance.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              6.9 Delivery Partner Relationship
            </h3>
            <p>
              <strong>6.9.1</strong> Delivery Partners are independent
              contractors and not employees, agents, or representatives of Flit.
              <br />
              <strong>6.9.2</strong> Flit does not control or direct the
              Delivery Partners in the performance of delivery services.
              <br />
              <strong>6.9.3</strong> The Delivery Partners maintain the sole
              right to determine when, where, and how they will perform the
              delivery services.
              <br />
              <strong>6.9.4</strong> Delivery Partners reserve the right to
              refuse to accept any delivery request at their sole discretion.
              <br />
              <strong>6.9.5</strong> You understand and agree that Flit does not
              guarantee that a Delivery Partner will complete a delivery request
              and may cancel the delivery request at any time.
            </p>
          </div>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            7. USER RESPONSIBILITIES
          </h3>

          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.1 Accurate Information
            </h3>
            <p>
              <strong>7.1.1</strong> You agree to provide accurate and complete
              information when using the Platform, including delivery addresses
              and contact information.
              <br />
              <strong>7.1.2</strong> You are responsible for any issues, delays,
              or failures resulting from inaccurate information provided by you.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.2 Proper Packaging
            </h3>
            <p>
              <strong>7.2.1</strong> You are responsible for ensuring that items
              are properly packaged for transportation and handling during the
              delivery process.
              <br />
              <strong>7.2.2</strong> Items should be packaged to prevent damage,
              leakage, or harm to the Delivery Partner or others.
              <br />
              <strong>7.2.3</strong> Flit and the Delivery Partner are not
              responsible for damages resulting from improper packaging.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.3 Availability for Pick-up and Delivery
            </h3>
            <p>
              <strong>7.3.1</strong> You must ensure that you or your designated
              representative is available at the pick-up and delivery locations
              at the scheduled times.
              <br />
              <strong>7.3.2</strong> If no one is available at the pick-up
              location, the Delivery Partner may cancel the request and you may
              be charged a cancellation fee.
              <br />
              <strong>7.3.3</strong> If no one is available at the delivery
              location, the Delivery Partner may leave the item in a safe place,
              return it to the pick-up location, or dispose of it if perishable,
              and you may be charged additional fees.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.4 Compliance with Laws
            </h3>
            <p>
              <strong>7.4.1</strong> You agree to comply with all Applicable
              Laws when using the Platform and services.
              <br />
              <strong>7.4.2</strong> You will not use the Platform or services
              for any unlawful or fraudulent purpose.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.5 Respectful Behavior
            </h3>
            <p>
              <strong>7.5.1</strong> You agree to treat Delivery Partners and
              Flit employees with respect and courtesy.
              <br />
              <strong>7.5.2</strong> Harassment, discrimination, threats, or
              abusive behavior towards Delivery Partners or Flit employees is
              strictly prohibited and may result in termination of your User
              Account.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              7.6 Prohibited Conduct
            </h3>
            <p>
              <strong>7.6.1</strong> You agree not to:
              <br />
              a) Use the Platform for any illegal or unauthorized purpose;
              <br />
              b) Violate any applicable laws or regulations;
              <br />
              c) Interfere with or disrupt the Platform or servers;
              <br />
              d) Attempt to gain unauthorized access to the Platform;
              <br />
              e) Reverse engineer, decompile, or disassemble any portion of the
              Platform;
              <br />
              f) Use any robot, spider, crawler, scraper, or other automated
              means to access the Platform;
              <br />
              g) Bypass or circumvent measures we may use to prevent or restrict
              access to the Platform;
              <br />
              h) Harass, threaten, or intimidate Delivery Partners or other
              Users;
              <br />
              i) Submit false or misleading information;
              <br />
              j) Use the Platform to send spam or promotional messages;
              <br />
              k) Impersonate another person or entity;
              <br />
              l) Infringe upon the rights of others;
              <br />
              m) Create multiple accounts for fraudulent or abusive purposes; or
              <br />
              n) Transfer, sublicense, or assign your account rights to another
              person without our consent.
            </p>
            <p>
              <strong>7.6.2</strong> Violation of these prohibitions may result
              in the termination of your User Account and potential legal
              action.
            </p>
          </div>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            8. PAYMENT TERMS
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.1 Fees and Charges
            </h3>
            <p>
              <strong>8.1.1</strong> You agree to pay all applicable fees and
              charges for the services as displayed on the Platform before
              confirming your order.
              <br />
              <strong>8.1.2</strong> The fees and charges may include:
              <br />
              a) Base delivery fee;
              <br />
              b) Distance-based charges;
              <br />
              c) Time-based charges;
              <br />
              d) Surge pricing during peak demand;
              <br />
              e) Waiting charges;
              <br />
              f) Special handling fees;
              <br />
              g) Cancellation fees;
              <br />
              h) Service tax and other applicable taxes; and
              <br />
              i) Any other fees or charges as mentioned on the Platform.
              <br />
              <strong>8.1.3</strong> The final amount payable will be displayed
              to you before you confirm your order. By confirming the order, you
              agree to pay the total amount shown.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.2 Dynamic Pricing
            </h3>
            <p>
              <strong>8.2.1</strong> Our pricing may be dynamic and may vary
              based on factors such as distance, time of day, demand, weather
              conditions, and other relevant factors.
              <br />
              <strong>8.2.2</strong> The applicable fees will be displayed to
              you before you confirm your order.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.3 Payment Methods
            </h3>
            <p>
              <strong>8.3.1</strong> We accept various payment methods as
              specified on our Platform, including:
              <br />
              a) Credit/debit cards;
              <br />
              b) Digital wallets;
              <br />
              c) UPI payments;
              <br />
              d) Net banking; and
              <br />
              e) Cash on delivery (where available).
              <br />
              <strong>8.3.2</strong> By providing a payment method, you
              represent and warrant that you are authorized to use the
              designated payment method and that the payment information you
              provide is true and accurate.
              <br />
              <strong>8.3.3</strong> You authorize us to charge your designated
              payment method for all fees and charges related to your use of the
              Platform.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.4 Payment Processing
            </h3>
            <p>
              <strong>8.4.1</strong> Payment processing services are provided by
              third-party payment processors.
              <br />
              <strong>8.4.2</strong> By using these services, you agree to
              comply with the terms and conditions of these third-party payment
              processors.
              <br />
              <strong>8.4.3</strong> Flit is not responsible for any errors,
              delays, or failures in payment processing by these third parties.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.5 Invoices and Receipts
            </h3>
            <p>
              <strong>8.5.1</strong> We will provide you with an electronic
              invoice or receipt for each transaction.
              <br />
              <strong>8.5.2</strong> These will be available in your User
              Account or sent to your registered email address.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.6 Price Changes
            </h3>
            <p>
              <strong>8.6.1</strong> We reserve the right to modify our fees and
              charges at any time, with or without notice to you.
              <br />
              <strong>8.6.2</strong> Any changes to our fees will be effective
              upon posting the updated fees on our Platform.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.7 Promotional Offers
            </h3>
            <p>
              <strong>8.7.1</strong> We may offer promotional discounts,
              referrals, or other incentives at our discretion.
              <br />
              <strong>8.7.2</strong> These promotions may be subject to
              additional terms and conditions and may be withdrawn at any time
              without notice.
              <br />
              <strong>8.7.3</strong> We reserve the right to:
              <br />
              a) Modify or discontinue any promotion;
              <br />
              b) Limit the use of promotions to certain Users or services; and
              <br />
              c) Revoke promotions if we believe they are being used in
              violation of these Terms or for fraudulent purposes.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.8 Non-Payment or Failed Payments
            </h3>
            <p>
              <strong>8.8.1</strong> If your payment method fails or is
              otherwise invalid, you remain responsible for any uncollected
              amounts.
              <br />
              <strong>8.8.2</strong> We reserve the right to suspend or
              terminate your access to the Platform or services in case of
              non-payment or failed payments.
              <br />
              <strong>8.8.3</strong> We may engage collection services to
              recover any unpaid amounts, and you will be responsible for all
              costs associated with such collection efforts.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              8.9 Subscription Services
            </h3>
            <p>
              <strong>8.9.1</strong> If we offer subscription services, you
              authorize us to charge your payment method on a recurring basis
              for the subscription period you have selected.
              <br />
              <strong>8.9.2</strong> You may cancel your subscription at any
              time by following the instructions on the Platform.
              <br />
              <strong>8.9.3</strong> If you cancel, your subscription will
              continue until the end of the current billing period, and you will
              not receive a refund for the current billing period.
            </p>
          </div>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            8. PAYMENT TERMS
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              9.1 Cancellation by User
            </h3>
            <p>
              <strong>9.1.1</strong> You may cancel a delivery request before it
              is accepted by a Delivery Partner without incurring any charges.
              <br />
              <strong>9.1.2</strong> Once a Delivery Partner has accepted your
              request, cancellation may result in a cancellation fee.
              <br />
              <strong>9.1.3</strong> The cancellation fee depends on the time
              elapsed since acceptance and whether the Delivery Partner has
              already reached the pick-up location.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              9.2 Cancellation by Delivery Partner or Flit
            </h3>
            <p>
              <strong>9.2.1</strong> A Delivery Partner or Flit may cancel a
              delivery request for various reasons, including but not limited
              to:
              <br />
              a) Safety concerns;
              <br />
              b) Prohibited items;
              <br />
              c) Unavailability of the Delivery Partner;
              <br />
              d) Extreme weather conditions;
              <br />
              e) Technical issues;
              <br />
              f) Inability to contact you; or
              <br />
              g) Any other reason deemed necessary by Flit or the Delivery
              Partner.
              <br />
              <strong>9.2.2</strong> In case of cancellation by the Delivery
              Partner or Flit, we may refund any fees already paid by you,
              subject to our refund policy.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              9.3 Refund Policy
            </h3>
            <p>
              <strong>9.3.1</strong> Refunds may be issued at our discretion for
              valid reasons such as:
              <br />
              a) Service not provided;
              <br />
              b) Unreasonable delays;
              <br />
              c) Damaged or lost items;
              <br />
              d) Incorrect charges; or
              <br />
              e) Technical errors.
              <br />
              <strong>9.3.2</strong> To request a refund, you must contact our
              customer support within 48 hours of the scheduled delivery time.
              <br />
              <strong>9.3.3</strong> You must provide all relevant details,
              including order ID, date, time, and reason for the refund request.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              9.4 Refund Processing
            </h3>
            <p>
              <strong>9.4.1</strong> Refunds will be processed to the original
              payment method, and the processing time may vary depending on your
              payment provider.
              <br />
              <strong>9.4.2</strong> Refunds to credit/debit cards typically
              take 5-7 business days, while refunds to digital wallets may be
              processed faster.
              <br />
              <strong>9.4.3</strong> We are not responsible for delays in refund
              processing by your payment provider.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              9.5 No-Show Policy
            </h3>
            <p>
              <strong>9.5.1</strong> If you are not available at the pick-up or
              delivery location at the scheduled time, the Delivery Partner may
              wait for a reasonable time (typically 5-10 minutes) before
              considering it a "no-show."
              <br />
              <strong>9.5.2</strong> In case of a no-show, you may be charged a
              cancellation fee or the full delivery fee, depending on the
              circumstances.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            10. INTELLECTUAL PROPERTY
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              10.1 Ownership
            </h3>
            <p>
              <strong>10.1.1</strong> The Platform, including all content,
              features, and functionality, is owned by Flit and its licensors
              and is protected by copyright, trademark, patent, trade secret,
              and other intellectual property or proprietary rights laws.
              <br />
              <strong>10.1.2</strong> These include, but are not limited to, the
              Flit name, logo, design, text, graphics, interfaces, code,
              software, and the selection and arrangement thereof.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              10.2 Limited License
            </h3>
            <p>
              <strong>10.2.1</strong> We grant you a limited, non-exclusive,
              non-transferable, and revocable license to access and use the
              Platform for personal, non-commercial purposes, subject to these
              Terms.
              <br />
              <strong>10.2.2</strong> This license does not include any right
              to:
              <br />
              a) Sell, resell, or commercially use the Platform;
              <br />
              b) Distribute, publicly perform, or publicly display any content
              from the Platform;
              <br />
              c) Modify or make derivative works based upon the Platform; or
              <br />
              d) Use any data mining, robots, or similar data gathering methods.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              10.3 Restrictions
            </h3>
            <p>
              <strong>10.3.1</strong> You may not:
              <br />
              a) Modify, copy, distribute, transmit, display, perform,
              reproduce, publish, license, create derivative works from,
              transfer, or sell any information or content obtained from the
              Platform;
              <br />
              b) Use any automated means, including robots, spiders, or
              scrapers, to access the Platform;
              <br />
              c) Decompile, reverse engineer, disassemble, or otherwise attempt
              to derive the source code of the Platform;
              <br />
              d) Frame or mirror any part of the Platform;
              <br />
              e) Use meta tags or any other "hidden text" utilizing our name or
              trademarks;
              <br />
              f) Remove any copyright, trademark, or other proprietary notices;
              <br />
              g) Use the Platform for any commercial purpose;
              <br />
              h) Access the Platform to build a competitive product or service;
              or
              <br />
              i) Use the Platform to send automated queries to any website or to
              send unsolicited commercial emails.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              10.4 User Feedback
            </h3>
            <p>
              <strong>10.4.1</strong> If you provide us with any feedback,
              suggestions, or ideas regarding the Platform ("Feedback"), you
              grant us a perpetual, worldwide, royalty-free, irrevocable,
              non-exclusive, sublicensable, and transferable license to use,
              reproduce, distribute, create derivative works of, publicly
              display, publicly perform, and otherwise exploit such Feedback for
              any purpose without compensation to you.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              10.5 Third-Party Content
            </h3>
            <p>
              <strong>10.5.1</strong> The Platform may display content from
              third parties or links to third-party websites or services.
              <br />
              <strong>10.5.2</strong> We do not control, endorse, or adopt any
              third-party content and shall have no responsibility for such
              content, including its accuracy, completeness, timeliness, or
              reliability.
              <br />
              <strong>10.5.3</strong> Your use of third-party content is at your
              own risk and may be subject to additional terms and conditions.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            11. PRIVACY POLICY
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              11.1 Privacy Policy
            </h3>
            <p>
              <strong>11.1.1</strong> Your privacy is important to us. Our
              Privacy Policy, which is incorporated into these Terms by
              reference, explains how we collect, use, and disclose information
              about you when you access or use our Platform.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              11.2 Consent
            </h3>
            <p>
              <strong>11.2.1</strong> By using the Platform, you consent to the
              collection and use of information as described in our Privacy
              Policy.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            12. USER CONTENT
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              12.1 User Content Defined
            </h3>
            <p>
              <strong>12.1.1</strong> "User Content" means any content that you
              submit, post, or transmit through the Platform, including reviews,
              comments, feedback, ideas, suggestions, or other materials.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              12.2 License Grant
            </h3>
            <p>
              <strong>12.2.1</strong> By submitting, posting, or transmitting
              User Content on or through the Platform, you grant Flit a
              worldwide, irrevocable, perpetual, non-exclusive, transferable,
              royalty-free license, with the right to sublicense, to use, copy,
              adapt, modify, distribute, publicly display, publicly perform,
              transmit, stream, broadcast, and otherwise exploit such User
              Content in any medium or format, without compensation to you.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              12.3 User Content Representations
            </h3>
            <p>
              <strong>12.3.1</strong> You represent and warrant that:
              <br /> a) You own or have the necessary rights to the User Content
              you post;
              <br /> b) The User Content does not infringe upon the intellectual
              property rights of any third party;
              <br /> c) The User Content does not violate any Applicable Laws or
              regulations;
              <br /> d) The User Content is not defamatory, obscene, indecent,
              abusive, offensive, harassing, violent, hateful, inflammatory, or
              otherwise objectionable; and
              <br /> e) The User Content does not promote sexual or pornographic
              material, violence, or discrimination based on race, sex,
              religion, nationality, disability, sexual orientation, or age.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              12.4 Monitoring and Removal
            </h3>
            <p>
              <strong>12.4.1</strong> We have the right, but not the obligation,
              to monitor, edit, or remove any User Content for any reason
              without notice.
              <br />
              <strong>12.4.2</strong> We are not responsible for User Content
              posted by Users and do not endorse any opinions expressed in User
              Content.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            13. SMS AND PUSH NOTIFICATIONS
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              13.1 SMS Communications
            </h3>
            <p>
              <strong>13.1.1</strong> By providing your mobile phone number, you
              agree to receive SMS messages from Flit regarding your User
              Account, delivery status, promotions, and other relevant
              information.
              <br />
              <strong>13.1.2</strong> Standard message and data rates may apply.
              <br />
              <strong>13.1.3</strong> You can opt out of receiving SMS messages
              by following the instructions provided in the SMS or by contacting
              our customer support.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              13.2 Push Notifications
            </h3>
            <p>
              <strong>13.2.1</strong> If you install our mobile application, you
              agree to receive push notifications from Flit regarding your User
              Account, delivery status, promotions, and other relevant
              information.
              <br />
              <strong>13.2.2</strong> You can opt out of receiving push
              notifications through your device settings.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            14. REFERRAL PROGRAM
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              14.1 Referral Program Terms
            </h3>
            <p>
              <strong>14.1.1</strong> We may offer a referral program that
              allows you to earn credits or other rewards by referring friends
              to use our Platform.
              <br />
              <strong>14.1.2</strong> The referral program is subject to
              additional terms and conditions, which will be provided when you
              participate in the program.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              14.2 Fraudulent Referrals
            </h3>
            <p>
              <strong>14.2.1</strong> Fraudulent referrals, including
              self-referrals, fictitious referrals, or referrals generated
              through automated means, are prohibited.
              <br />
              <strong>14.2.2</strong> We reserve the right to withhold or
              reverse referral rewards if we suspect fraudulent activity.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            15. LIMITATION OF LIABILITY
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              15.1 Disclaimer of Warranties
            </h3>
            <p>
              <strong>15.1.1</strong> THE PLATFORM AND SERVICES ARE PROVIDED "AS
              IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
              NON-INFRINGEMENT, AND FREEDOM FROM COMPUTER VIRUS OR OTHER HARMFUL
              CODE.
              <br />
              <strong>15.1.2</strong> WE DO NOT WARRANT THAT THE PLATFORM OR
              SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, THAT
              DEFECTS WILL BE CORRECTED, OR THAT THE PLATFORM OR THE SERVERS
              THAT MAKE THE PLATFORM AVAILABLE ARE FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              15.2 Limitation of Liability
            </h3>
            <p>
              <strong>15.2.1</strong> TO THE FULLEST EXTENT PERMITTED BY
              APPLICABLE LAW, IN NO EVENT SHALL FLIT, ITS AFFILIATES, DIRECTORS,
              EMPLOYEES, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
              SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT
              LIMITED TO LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER
              INTANGIBLE LOSSES, RESULTING FROM:
            </p>
            <ul className="list-disc pl-5">
              <li>
                Your access to or use of or inability to access or use the
                Platform;
              </li>
              <li>
                Any conduct or content of any third party on the Platform;
              </li>
              <li>Any content obtained from the Platform;</li>
              <li>
                Unauthorized access, use, or alteration of your transmissions or
                content;
              </li>
              <li>The actions or inactions of Delivery Partners;</li>
              <li>Loss or damage to your items during delivery;</li>
              <li>Delays in delivery; or</li>
              <li>Any other matter relating to the Platform or Services.</li>
            </ul>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              15.3 Exclusions
            </h3>
            <p>
              <strong>15.3.1</strong> Some jurisdictions do not allow the
              exclusion of implied warranties or the limitation or exclusion of
              liability for incidental or consequential damages, so the above
              limitations or exclusions may not apply to you.
              <br />
              <strong>15.3.2</strong> In such cases, our liability will be
              limited to the maximum extent permitted by law.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              15.4 Delivery Partner Actions
            </h3>
            <p>
              <strong>15.4.1</strong> Flit is not liable for the acts, errors,
              omissions, representations, warranties, breaches, or negligence of
              any Delivery Partner or for any personal injuries, death, property
              damage, or other damages or expenses resulting from interactions
              with Delivery Partners.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              15.5 Item Value and Insurance
            </h3>
            <p>
              <strong>15.5.1</strong> Our liability for lost or damaged items is
              limited to the lesser of:
            </p>
            <ul className="list-disc pl-5">
              <li>
                The value of the item as declared by you at the time of booking;
              </li>
              <li>The actual value of the item; or</li>
              <li>INR 2,000, whichever is lower.</li>
            </ul>
            <p>
              <strong>15.5.2</strong> For items valued over INR 2,000, you must
              arrange for separate insurance coverage.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            16. INDEMNIFICATION
          </h3>
          <div className="flex flex-col gap-3">
            <p>
              <strong>16.1</strong> You agree to indemnify, defend, and hold
              harmless Flit, its affiliates, officers, directors, employees, and
              agents from and against any and all claims, liabilities, damages,
              losses, costs, expenses, or fees (including reasonable attorneys'
              fees) arising from: a) Your use of the Platform; b) Your violation
              of these Terms; c) Your violation of any rights of another person
              or entity; d) Your violation of any Applicable Laws or
              regulations; e) Your User Content; f) Your interaction with any
              Delivery Partner; g) Your breach of any representations or
              warranties made by you; or h) Any items you request to be
              delivered through the Platform.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            18. MODIFICATIONS TO TERMS
          </h3>
          <div className="flex flex-col gap-3">
            <p>
              <strong> 18.1</strong> We reserve the right to modify these Terms
              at any time by posting the revised Terms on our Platform.
              <br />
              <strong> 18.2</strong> Your continued use of the Platform after
              any such changes constitutes your acceptance of the new Terms.
              <br />
              <strong> 18.3</strong> If you do not agree to the new Terms, you
              must stop using the Platform.
              <br />
              <strong> 18.4</strong> We will make reasonable efforts to notify
              you of material changes to these Terms, but it is your
              responsibility to check these Terms periodically for changes.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            19. MODIFICATIONS TO THE PLATFORM
          </h3>
          <div className="flex flex-col gap-3">
            <p>
              <strong> 19.1</strong> We reserve the right to modify, suspend, or
              discontinue the Platform or any part thereof, temporarily or
              permanently, with or without notice.
              <br />
              <strong> 19.2</strong> You agree that we shall not be liable to
              you or to any third party for any modification, suspension, or
              discontinuance of the Platform.
            </p>
          </div>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            20. GOVERNING LAW AND DISPUTE RESOLUTION
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              20.1 Governing Law
            </h3>
            <p>
              <strong>20.1.1</strong> These Terms shall be governed by and
              construed in accordance with the laws of India, without regard to
              its conflict of law principles.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              20.2 Dispute Resolution
            </h3>
            <p>
              <strong>20.2.1</strong> Any dispute arising out of or in
              connection with these Terms shall be referred to and resolved by
              arbitration in accordance with the Arbitration and Conciliation
              Act, 1996.
              <br />
              <strong>20.2.2</strong> The arbitration shall be conducted by a
              sole arbitrator appointed by Flit.
              <br />
              <strong>20.2.3</strong> The place of arbitration shall be
              Bangalore, India, and the language of arbitration shall be
              English.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              20.3 No Class Actions
            </h3>
            <p>
              <strong>20.3.1</strong> You agree that any dispute resolution
              proceedings will be conducted only on an individual basis and not
              in a class, consolidated, or representative action.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              20.4 Injunctive Relief
            </h3>
            <p>
              <strong>20.4.1</strong> Notwithstanding the foregoing, Flit may
              seek injunctive or other equitable relief to protect its
              intellectual property rights or to prevent unauthorized use of the
              Platform in any court of competent jurisdiction.
            </p>
          </div>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            21. CONFIDENTIALITY
          </h3>
          <div className="flex flex-col gap-3">
            <p>
              <strong> 21.1</strong> You agree to maintain the confidentiality
              of any proprietary or confidential information received from Flit,
              including business plans, marketing strategies, user data, and
              other non-public information.
              <br />
              <strong> 21.2</strong> You shall not disclose such information to
              any third party without our prior written consent.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            22. USER SUPPORT
          </h3>
          <div className="flex flex-col gap-3">
            <p>
              <strong> 22.1</strong> We provide user support services to address
              your questions, concerns, or complaints regarding the Platform.
              <br />
              <strong> 22.2</strong> You may contact our user support team
              through the contact information provided on the Platform.
            </p>
          </div>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            23. MISCELLANEOUS
          </h3>
          <div className="flex flex-col gap-3">
            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.1 Entire Agreement
            </h3>
            <p>
              These Terms, together with the Privacy Policy and any additional
              terms and conditions incorporated by reference, constitute the
              entire agreement between you and Flit regarding the Platform and
              supersede all prior agreements and understandings.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.2 Severability
            </h3>
            <p>
              If any provision of these Terms is held to be invalid or
              unenforceable, such provision shall be struck, and the remaining
              provisions shall be enforced to the fullest extent possible under
              the law. The invalidity or unenforceability of any provision shall
              not affect the validity or enforceability of any other provision.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.3 Waiver
            </h3>
            <p>
              Our failure to enforce any right or provision of these Terms will
              not be considered a waiver of such right or provision. No waiver
              of any provision of these Terms shall be effective unless it is in
              writing and signed by an authorized representative of Flit.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.4 Assignment
            </h3>
            <p>
              You may not assign or transfer these Terms or your rights and
              obligations hereunder without our prior written consent. We may
              assign or transfer these Terms without your consent to any
              affiliate or subsidiary, or in connection with a merger,
              acquisition, corporate reorganization, or sale of all or
              substantially all of our assets.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.5 Relationship of the Parties
            </h3>
            <p>
              Nothing in these Terms shall be construed as creating any agency,
              partnership, joint venture, employment, or franchise relationship
              between you and Flit. Neither you nor Flit has any authority to
              bind the other in any way.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.6 Third-Party Beneficiaries
            </h3>
            <p>
              These Terms do not and are not intended to confer any rights or
              remedies upon any person other than you and Flit, except as
              expressly stated.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.7 Notices
            </h3>
            <p>
              All notices required or permitted under these Terms shall be in
              writing and shall be deemed effective when:
            </p>
            <ul className="list-disc pl-6">
              <li>Delivered in person</li>
              <li>Sent by registered or certified mail</li>
              <li>Sent by overnight courier</li>
              <li>Sent by email (with confirmation of receipt)</li>
            </ul>
            <p>
              Notices to Flit shall be sent to the address specified in the
              "Contact Information" section. Notices to you shall be sent to the
              address or email address specified in your User Account.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.8 Electronic Communications
            </h3>
            <p>
              By using the Platform, you consent to receive communications from
              us electronically, including emails, text messages, push
              notifications, and notices within the Platform. You agree that all
              agreements, notices, disclosures, and other communications that we
              provide to you electronically satisfy any legal requirement that
              such communications be in writing.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.9 Survival
            </h3>
            <p>
              The provisions of these Terms that by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity,
              and limitations of liability.
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.10 Interpretation
            </h3>
            <p>
              The headings used in these Terms are for convenience only and
              shall not affect the interpretation of these Terms. Words
              importing the singular number include the plural and vice versa.
              References to "including" or "includes" shall be deemed to be
              followed by the words "without limitation."
            </p>

            <h3 className="text-lg font-semibold text-[#131D2D]">
              23.11 Contact Information
            </h3>
            <p>
              If you have any questions or concerns about these Terms, please
              contact us at:
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@goflash.in" className="text-blue-600">
                support@goflash.in
              </a>
              <br />
              <strong>Phone:</strong>{" "}
              <a href="tel:+917045063838" className="text-blue-600">
                +91 7045063838
              </a>
            </p>
          </div>
        </div>
        <p className="text-sm text-gray-500">Last Updated: 3rd March, 2025</p>
      </div>
    </div>
  );
};

export default TermOfService;
